module.exports = __webpack_public_path__ + "static/img/file.1f9e5911.svg";